
import type { AsyncDataOptions } from '#app';
import type { FetchOptions } from 'ofetch';
import FetchFactory from '../factory';


class TicketsModule extends FetchFactory<ITicket> {
  private RESOURCE = '/tickets';

  async index(
    query: string,
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<ITicket[]>>
  ) {
    return useAsyncData(
      "tickets",
      () => {
        return this.call(
          `${this.RESOURCE}?${query}`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

  async me(
    query: string,
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<ITicket[]>>
  ) {
    return useAsyncData(
      "tickets/me",
      () => {
        return this.call(
          `${this.RESOURCE}/me?${query}`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

}

export default TicketsModule;

